import './index.css'
import React, { lazy, Suspense, useContext, useEffect, useState } from 'react'
import { AppBar, Box, Drawer, IconButton, Toolbar, useMediaQuery } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { createBrowserRouter, RouterProvider, Outlet, Navigate } from 'react-router-dom' // 导入 BrowserRouter
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Cookies from 'js-cookie'

import Navbar, { NavItemProps, NavbarProps } from './sidebar/Navbar'
import AnnouncementBar from './sidebar/AnnouncementBar'
import Sidebar from './sidebar/rightBar' // 导入侧边栏组件
import { Logout, PrivateRoute, UserDataContext, UserDataProvider } from './auth'
import { CompName, GameDataProvider } from './game'
import { zhCN } from '@mui/material/locale'
const HeroDataDisplay = lazy(() => import('./heropage/buildsys'))
const MyEditor = lazy(() => import('./textEditor'))
const JEditor = lazy(() => import('./adminpage/jsonEditor'))
const WodEditor = lazy(() => import('./adminpage/wodEditor'))
const DragEditor = lazy(() => import('./heropage/strategy/strategyEditor'))
const Introduce = lazy(() => import('./aboutpage/introduce'))
const Questionnaire = lazy(() => import('./aboutpage/questionnaire'))
const Nothing = lazy(() => import('./aboutpage/nothing'))
const DuelSys = lazy(() => import('./missionpage/duelsys'))
const Heros = lazy(() => import('./heropage/hero'))
const NoAuth = lazy(() => import('./network/noauth'))
const Forbidden = lazy(() => import('./network/forbidden'))
const Team = lazy(() => import('./teampage/team'))
const Mission = lazy(() => import('./missionpage/missionsys'))
const MissionDetails = lazy(() => import('./teampage/missionDetail'))
const HeroStrategy = lazy(() => import('./heropage/strategy/heroStrategy').then(m => ({ default: m.HeroStrategy })))
const NPCStrategy = lazy(() => import('./heropage/strategy/npcStrategy').then(m => ({ default: m.NPCStrategy })))
const SkillInfo = lazy(() => import('./infopage/skill'))
const CreatorInstructions = lazy(() => import('./aboutpage/creatorInstructions'))
const PlayerGuide = lazy(() => import('./aboutpage/playerGuide'))
const BattleGuide = lazy(() => import('./aboutpage/battleGuide'))
const App = lazy(() => import('./map/src/App'))
const Editor = lazy(() => import('./map/src/editor'))
const ShowEquipmentBuilding = lazy(() => import('./heropage/equipment').then(m => ({ default: m.ShowEquipmentBuilding })))
const ShowStorage = lazy(() => import('./heropage/storage/show').then(m => ({ default: m.ShowStorage })))
const MagicBook = lazy(() => import('./map/src/magickbook'))

const theme = createTheme( {
    palette: {
        primary: {
            main: '#ffc107',
        },
        secondary: {
            main: '#ff9100',
        },
        background: {
            paper: "#555555"
        },
        text: {
            primary: "#ffffff",
            secondary: "#eeeeee"
        }
    },
    typography: {
        h6: {
            color: "#eeeeee",
        },
    },
}, zhCN )

const playContents = [
    // {
    //     path: "新闻"
    // },
    {
        path: "英雄",
        children: [
            {
                path: "我的英雄",
                element:
                    <Heros />
            },
            // {
            //     path: "属性",
            // },
            {
                path: "技能",
                element:
                    <HeroDataDisplay />
            },
            {
                path: "装备",
                element:
                    <ShowEquipmentBuilding />
            },
            {
                path: "个人仓库",
                element:
                    <ShowStorage />
            },
            {
                path: "团队仓库",
                element:
                    <ShowStorage team />
            },
            {
                path: "设置",
                element:
                    <HeroStrategy />
            },
        ]
    },
    {
        path: "团队",
        children: [
            {
                path: "我的团队",
                element:
                    <Team />
            },
            {
                path: "战报",
                element:
                    <MissionDetails />
            }
        ]
    },
    {
        path: "地城",
        children: [
            {
                path: "地城",
                element:
                    <Mission />
            }
        ]
    },
    // {
    //     path: "市场"
    // },
    {
        path: "酒馆",
        children: [
            {
                path: "决斗",
                element: <DuelSys />,
            }
        ]
    },
    // {
    //     path: "jediter",
    //     element: <JEditor name='测试' submitFunc={ function () { alert( "测试已保存（不会持久化）" ) } } />
    // },
    // {
    //     path: "editer",
    //     element: <MyEditor />
    // },
]
const manageContents = [
    {
        path: "管理员",
        children: [
            {
                path: "属性",
                element: <WodEditor name={ CompName.attr } title='属性' />,
            },
            {
                path: "资源",
                element: <WodEditor name={ CompName.resource } title='资源' />,
            },
            {
                path: "动作",
                element: <WodEditor name={ CompName.action } title='动作' />,
            },
            {
                path: "效果",
                element: <WodEditor name={ CompName.effect } title='效果' />,
            },
            {
                path: "技能",
                element: <WodEditor name={ CompName.skill } title='技能' />,
            },
            {
                path: "种族",
                element: <WodEditor name={ CompName.race } title='种族' />,
            },
            {
                path: "职业",
                element: <WodEditor name={ CompName.profession } title='职业' />,
            },
            {
                path: "地城",
                element: <WodEditor name={ CompName.mission } title='地城' />,
            },
            {
                path: "NPC团体",
                element: <WodEditor name={ CompName.enemy } title='NPC团体' />,
            },
            {
                path: "NPC",
                element: <WodEditor name={ CompName.npc } title='NPC' />,
            },
            {
                path: "NPC战术",
                element: <NPCStrategy />,
            },
            {
                path: "装备",
                element: <WodEditor name={ CompName.equipment } title='装备' />,
            },
            {
                path: "装备类型",
                element: <WodEditor name={ CompName.equipmentType } title='装备类型' />,
            },
            {
                path: "装备部位",
                element: <WodEditor name={ CompName.equipmentPart } title='装备部位' />,
            },
            {
                path: "贴图",
                element:
                    <Editor />
            },
        ]
    },
]
const infoContents = [
    {
        path: "详细信息",
        children: [
            {
                path: "skill/:skillName",
                element:
                    <SkillInfo />
            },
        ]
    }
]

const webContents = [
    {
        path: "noauth",
        element:
            <NoAuth />
    },
    {
        path: "forbidden",
        element:
            <Forbidden />
    }
]

const aboutContents = [
    {
        path: "关于网站",
        children: [
            {
                path: "介绍",
                element:
                    <Introduce />
            },
            {
                path: "游历指南",
                element:
                    <PlayerGuide />
            },
            {
                path: "创作者说明书",
                element:
                    <CreatorInstructions />
            },
            {
                path: "战报阅读",
                element:
                    <BattleGuide />
            },
            {
                path: "调查问卷",
                element:
                    <Questionnaire />
            }
        ]
    },
    {
        path: "退出登录",
        element:
            <Logout />
    },
    {
        path: "map-test",
        element:
            <App />
    },
    {
        path: "魔法全书",
        element:
            <MagicBook />
    },
]


function browserRouter () {
    return createBrowserRouter( [
        {
            path: "/",
            element: <PrivateRoute auth="session"><Root /></PrivateRoute>,
            children: [ ...playContents, ...manageContents ],
        },
        {
            path: "*",
            element: <Root />,
            children: [ ...webContents, ...aboutContents, ...infoContents ],
        }
    ] )
}

function Root () {
    const ctx = useContext( UserDataContext )
    if ( !ctx ) {
        throw new Error( 'useUserData must be used within a UserDataProvider' )
    }
    var mode = ""
    console.log( ctx.userData )
    if ( ctx.userData ) {
        if ( ctx.userData.role >= 1 ) {
            mode = "manage"
        } else {
            mode = "play"
        }
    }
    console.log( mode )

    // 窄屏导航抽屉：<900px 侧边栏收进汉堡；右栏（Sidebar）只在真正手机 <600px 隐藏
    const isNavMobile = useMediaQuery( theme.breakpoints.down( 'md' ) )
    const isNarrow = useMediaQuery( theme.breakpoints.down( 'sm' ) )
    const [ drawerOpen, setDrawerOpen ] = useState( false )
    const navGroup = (
        <>
            { mode === "manage" && (
                <Navbar navs={ manageContents } />
            ) }
            { ( mode === "manage" || mode === "play" ) && (
                <Navbar navs={ playContents } />
            ) }
            <Navbar navs={ aboutContents } />
        </>
    )

    return (
        <ThemeProvider theme={ theme }>
            <div className="container">
                <div className="announcement-bar-container">
                    <AnnouncementBar />
                </div>
                { isNavMobile && (
                    <AppBar position="sticky" sx={ { background: '#444', mb: 1 } }>
                        <Toolbar variant="dense">
                            <IconButton edge="start" color="inherit" aria-label="打开菜单"
                                onClick={ () => setDrawerOpen( true ) }>
                                <MenuIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                ) }
                <Drawer anchor="left" open={ isNavMobile && drawerOpen } onClose={ () => setDrawerOpen( false ) }>
                    <Box sx={ { width: 240, height: '100%', p: 2, bgcolor: '#333', overflowY: 'auto' } }
                        onClick={ ( e ) => {
                            if ( ( e.target as HTMLElement ).closest( 'a' ) ) {
                                setDrawerOpen( false )
                            }
                        } }>
                        { navGroup }
                        <Box sx={ { mt: 2, pt: 2, borderTop: '1px solid', borderColor: 'divider' } }>
                            <Sidebar />
                        </Box>
                    </Box>
                </Drawer>
                <div className="content-container">
                    { !isNavMobile && (
                        <div className="sidebar">
                            { navGroup }
                        </div>
                    ) }
                    <div className="content">
                        <Suspense fallback={ <div style={ { padding: 24, textAlign: 'center', color: '#aaa' } }>加载中…</div> }>
                            <Outlet />
                        </Suspense>
                    </div>
                    { !isNarrow && <Sidebar /> }
                </div>
            </div>
        </ThemeProvider>
    )
}

ReactDOM.createRoot(
    document.getElementById( 'root' ) as HTMLElement
).render(
    <React.StrictMode>
        <UserDataProvider>
            <GameDataProvider>
                <RouterProvider router={ browserRouter() } />
            </GameDataProvider>
        </UserDataProvider>
    </React.StrictMode>,
)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
